export class FileInput {
    private readonly _fileNames;

    constructor(private readonly _files: File[], private readonly delimiter: string = ', ') {
      if ( !(this._files instanceof FileInput) && Array.isArray(this._files)) {
        this._fileNames = this._files.map((f: File) => f.name).join(delimiter);
      } else {
        const fileArray: File[] = this._files.files;
        this._fileNames = fileArray.map((f: File) => f.name).join(delimiter);
      }

    }

    get files() {
      return this._files || [];
    }

    get fileNames(): string {
      return this._fileNames;
    }
  }
